/* eslint-disable react/prop-types */
/* eslint no-unused-vars : "off" */
import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';
import { GET_MODULE_TYPE_LIST } from 'modules/transaction/constants';
import * as actions from 'modules/transaction/actions';
import Loader from "modules/common/components/Loader";

const BASE_URL = process.env.REACT_APP_WS;

const authenticate = async (exchangeCode) => {
  try {
    const raw = await fetch(new URL('/api/v1/taxpayers/super_app_sso_auth', BASE_URL), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ exchange_code: exchangeCode })
    })
    const res = await raw.json();
    return { status: raw?.status, data: res };
  } catch (err) {
    return { status: 500, message: 'Something went wrong!' };
  }
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const MAP_MODULE = {
  'bpls': {
    system_module_id: '17',
    application_status_id: '21',
    transaction_type: 'NEW',
    root_url: '/create-transaction/lgu-bpls',
  },
  'bpls-new': {
    system_module_id: '17',
    application_status_id: '21',
    transaction_type: 'NEW',
    root_url: '/create-transaction/e2e-business-permit-new',
  },
  'bpls-renewal': {
    system_module_id: '17',
    application_status_id: '22',
    transaction_type: 'RENEWAL',
    root_url: '/create-transaction/e2e-business-permit-renew',
  },
  'bpls-quarterly': {
    system_module_id: '17',
    application_status_id: '33',
    transaction_type: 'QUARTERLY',
    root_url: '/create-transaction/e2e-business-permit-quarterly',
  },
  'bpls-delinquent': {
    system_module_id: '17',
    application_status_id: '34',
    transaction_type: 'DELINQUENT',
    root_url: '/create-transaction/e2e-business-permit-delinquent',
  },
  'bpls-change': {
    system_module_id: '17',
    application_status_id: '27',
    transaction_type: 'CHANGE',
    root_url: '/create-transaction/e2e-business-permit-change',
  },
  'bpls-retirement': {
    system_module_id: '17',
    application_status_id: '37',
    transaction_type: 'RETIREMENT',
    root_url: '/create-transaction/e2e-business-permit-retirement',
  },
  'civil-registry': {
    system_module_id: '3',
    application_status_id: '10',
    transaction_type: 'BIRTH CERTIFICATE',
    root_url: '/create-transaction/lgu-civil-registry',
  },
  'cedula': {
    system_module_id: '4',
    application_status_id: '8',
    transaction_type: 'INDIVIDUAL',
    root_url: '/create-transaction/lgu-cedula',
  },
  'elgu-home': {
    system_module_id: '4',
    application_status_id: '8',
    transaction_type: 'INDIVIDUAL',
    root_url: '/',
  },
  'elgu-service': {
    system_module_id: '4',
    application_status_id: '8',
    transaction_type: 'INDIVIDUAL',
    root_url: '/create-transaction/elgu-service',
  },
  'elgu-transaction': {
    system_module_id: '4',
    application_status_id: '8',
    transaction_type: 'INDIVIDUAL',
    root_url: '/create-transaction/elgu-transaction',
  },
  'elgu-news': {
    system_module_id: '4',
    application_status_id: '8',
    transaction_type: 'INDIVIDUAL',
    root_url: '/create-transaction/elgu-news',
  }
}

function transformModule(raw, other) {
  return {
    ...other,
    icon: raw?.attributes?.photo,
    label: raw?.attributes?.description,
    module_type: raw?.attributes?.name,
    system_module_id: raw?.id,
  }
}

function SsoAuthPage({ moduleTypeList, getModuleTypeList }) {
  const [error, setError] = useState(undefined);
  const params = useParams();
  const query = useQuery();
  const exchangeCode = query.get("exchange_code")

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();

    getModuleTypeList();
  }, []);

  const moduleType = useMemo(() => {
    if ((moduleTypeList || []).length < 1) return null;
    const mapper = MAP_MODULE[params.module];
    const m = moduleTypeList.find((x) => x.id === mapper?.system_module_id);
    if (!m) {
      setError({ message: `Module not found! (${params.module || 'n/a'})` });
      return null;
    }
    return {
      transaction: transformModule(m, {
        application_status_id: mapper?.application_status_id,
        transaction_type: mapper?.transaction_type,
      }),
      root_url: mapper?.root_url,
    };
  }, [moduleTypeList]);

  useEffect(() => {
    if (!moduleType) return;
    if (!exchangeCode) {
      setError({
        message: 'Incomplete parameters!',
      })
      return;
    }
    (async () => {
      const res = await authenticate(exchangeCode);
      if (res?.status !== 201) {
        setError({
          // message: res?.data?.errors?.[0]?.detail || res?.message || 'Something went wrong!',
          message: `Something went wrong! ${exchangeCode}`,
        })
        return;
      }

      const profile = _.get(res?.data?.data, "attributes");
      localStorage.setItem("token", res?.data?.token);
      localStorage.setItem("profile", JSON.stringify(profile));
      sessionStorage.setItem("is_sso", '1');
      localStorage.setItem("transaction", JSON.stringify(moduleType.transaction));
      window.location.replace(moduleType.root_url);
    })()
  }, [exchangeCode, moduleType]);
  return (
    <Loader/>
  )
}
const enhance = _.flowRight([connect(({ api }) => ({
  moduleTypeList: _.get(api, `${GET_MODULE_TYPE_LIST}`, []).list || [],
}), actions)]);

export default enhance(SsoAuthPage);